import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Button, Icon, Form } from "../..";

/**
 * Table Rich Popup
 */
import { jsx as _jsx } from "react/jsx-runtime";
var TableRichPopup = function TableRichPopup(props) {
  var isVisible = props.isVisible,
    comp = props.comp,
    item = props.item,
    onSave = props.onSave,
    mountNode = props.mountNode,
    closePopup = props.closePopup,
    onOpen = props.onOpen,
    onClose = props.onClose,
    testClassName = props.testClassName,
    labelColonne = props.labelColonne,
    indexColonne = props.indexColonne;
  return /*#__PURE__*/_jsx(Popup, Object.assign({
    className: "popupTableRich"
  }, comp.popupProps, {
    on: "click",
    mountNode: mountNode,
    content: /*#__PURE__*/_jsx(Form, {
      className: "popupTableRichForm",
      children: /*#__PURE__*/_jsx(comp.component, Object.assign({}, item.props, {
        closePopup: closePopup,
        onSave: onSave,
        labelColonne: labelColonne,
        indexColonne: indexColonne
      }))
    }),
    pinned: true,
    position: "bottom center",
    size: "huge",
    flowing: true,
    onClose: onClose,
    hideOnScroll: true
    // hoverable
    ,
    trigger: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return onOpen();
      },
      className: "iconActions",
      inline: true
      // icon={comp.icon}
      ,
      icon: /*#__PURE__*/_jsx(Icon, {
        name: comp.icon,
        className: testClassName
      }),
      size: "small",
      style: {
        visibility: !_.isNil(isVisible) && isVisible() ? 'visible' : 'hidden'
      }
    })
  }));
};
TableRichPopup.handledProps = ["closePopup", "comp", "indexColonne", "isVisible", "item", "labelColonne", "mountNode", "onClose", "onOpen", "onSave", "testClassName"];
TableRichPopup.propTypes = {
  isVisible: PropTypes.func,
  onSave: PropTypes.func,
  mountNode: PropTypes.node,
  comp: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  item: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  closePopup: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  labelColonne: PropTypes.string,
  indexColonne: PropTypes.number,
  testClassName: PropTypes.string
};
TableRichPopup.defaultProps = {
  isVisible: null,
  onSave: null,
  // mountNode: null,
  comp: {},
  item: {},
  closePopup: null,
  onOpen: null,
  onClose: null,
  labelColonne: '',
  indexColonne: 0,
  testClassName: null
};
export default TableRichPopup;